import React from 'react';
import {
  Table, TableHead, TableRow, TableCell, TableBody,
  TableContainer, IconButton, Tooltip, Typography
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import StatusChip from '../StatusChip';
import EmptyState from '../ui/EmptyState';
import SkeletonBlock from '../ui/SkeletonBlock';

const statusMap = {
  0: 'Pending',
  1: 'Approved',
  2: 'Rejected',
  'Pending': 'Pending',
  'Approved': 'Approved',
  'Rejected': 'Rejected'
};

export default function MyShortAbsences({ absences = [], loading, onCancel }) {
  if (loading) return <SkeletonBlock lines={3} />;

  if (!absences.length) {
    return <EmptyState message="No short absence requests yet" />;
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Time</TableCell>
            <TableCell>Duration</TableCell>
            <TableCell>Note</TableCell>
            <TableCell>Status</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {absences.map((a) => {
            const status = statusMap[a.status] || a.statusText || 'Unknown';
            const isPending = status === 'Pending';
            return (
              <TableRow key={a.id}>
                <TableCell>{a.date}</TableCell>
                <TableCell>{a.startTime} - {a.endTime}</TableCell>
                <TableCell>{a.durationHours}h</TableCell>
                <TableCell>
                  <Typography variant="body2" sx={{ maxWidth: 200 }} noWrap title={a.note}>
                    {a.note || '-'}
                  </Typography>
                </TableCell>
                <TableCell>
                  <StatusChip status={status} />
                </TableCell>
                <TableCell align="right">
                  {isPending && (
                    <Tooltip title="Cancel request">
                      <IconButton size="small" color="error" onClick={() => onCancel?.(a.id)}>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                  {a.approverComments && (
                    <Tooltip title={`Approver: ${a.approverComments}`}>
                      <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                        💬
                      </Typography>
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

